<template>
  <!-- Usage  -->
  <!-- <Loader :height="80"/> -->
  <!--  -->
  <section
    :style="{ height: height ? height + 'vh' : '60vh' }"
    class="relative flex flex-col items-center justify-center w-full"
  >
    <!-- gradient background  -->
    <section
      class="container relative flex items-center justify-center rounded-full"
    >
      <!-- curve  -->
      <div
        class="absolute bottom-0 w-[16px] h-[16px] bg-[#30b354] rounded-full"
      ></div>
      <!--  -->
      <!-- white background  -->
      <div
        class="flex items-center justify-center p-1 bg-[#fff] rounded-full inner-container"
      ></div>
      <!--  -->
    </section>
    <!--  -->

    <img :src="epumpLogo" alt="Center Image" class="center-image" />
  </section>
</template>

<script>
//assets
import epumpLogo from "@/assets/svg/epumpLogo.svg";

export default {
  name: "Loader",
  props: {
    height: {
      required: false,
      type: [String, Number],
      default: 60,
    },
  },
  data() {
    return { epumpLogo };
  },
};
</script>

<style scoped>
.container {
  width: 80px;
  height: 80px;
  background: conic-gradient(
    from 176.19deg at 51.67% 37.5%,
    #30b354 0deg,
    rgba(21, 77, 36, 0.06) 360deg
  );
  animation: revolver 1s linear infinite;
}

@keyframes revolver {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}
.inner-container {
  width: 50px;
  height: 50px;
}

.center-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}
</style>
